import { useState, useEffect } from 'react';
import { PillButtons } from '../input';

export const Artifacts = ({ artifacts }) => {
  const [tab, setTab] = useState(0);
  const choices = artifacts.map((it, idx) => {
    const key = Object.keys(it)[0];
    const bytes = JSON.stringify(it).length;
    return [idx, `${key} (${(bytes / 1000).toFixed(2)}kb)`];
  });

  const nodes = artifacts
    .map((it) => {
      if (typeof it.answer == 'string') {
        return <pre>{it.answer}</pre>;
      } else if (typeof it.answer == 'object') {
        return <pre>{JSON.stringify(it.answer, null, 2)}</pre>;
      } else {
        return <pre>{JSON.stringify(it, null, 2)}</pre>;
      }
    })
    .map((body, idx) =>
      idx == tab ? (
        <div
          key={idx}
          style={{ border: '1px solid #ccc', borderRadius: 8, background: '#f3f3f3', padding: 10, overflowX: 'scroll' }}
        >
          {body}
        </div>
      ) : null,
    );

  console.log('choices', choices);

  return (
    <div>
      <PillButtons value={tab} onChange={setTab} choices={choices} />
      <br />
      {nodes}
    </div>
  );
};
